import * as moment from 'moment';

export const sortAlphabetically = <ArrayType>(list: ArrayType[], attribute: string, reverse = false): ArrayType[] => {
	const copy = [...list];
	copy.sort((a, b) =>
		reverse
			? b[attribute].localeCompare(a[attribute], 'en', { sensitivity: 'base' })
			: a[attribute].localeCompare(b[attribute], 'en', { sensitivity: 'base' })
	);
	return copy;
};

export const sortNumerically = <ArrayType>(list: ArrayType[], attribute: string, reverse = false): ArrayType[] => {
	const copy = [...list];
	copy.sort((a, b) => (reverse ? (b > a ? -1 : b === a ? 0 : 1) : a > b ? -1 : b === a ? 0 : 1));
	return copy;
};

export const sortByDate = <ArrayType>(list: ArrayType[], attribute: string, reverse = false): ArrayType[] => {
	const copy = [...list];
	copy.sort((a, b) =>
		reverse ? moment(b[attribute]).unix() - moment(a[attribute]).unix() : moment(a[attribute]).unix() - moment(b[attribute]).unix()
	);
	return copy;
};
